import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Button } from 'antd';
import { actions } from '../actions/expired-requests.actions';
import { requestsActions } from '../containers/Requests/requests.actions';

const getExpiredRequestsStore = (state) => state.expiredRequestsStore;

const selectCount = (state) => getExpiredRequestsStore(state).count;
const selectIsFetching = (state) =>
  getExpiredRequestsStore(state).fetchIds.size > 0;
const selectExpiredList = (state) => state.requestsStore.expiredList;
const selectRelatedToExpired = (state) => state.filterStore.relatedToExpired;

const DspxExpiredReqButton = () => {
  const count = useSelector(selectCount);
  const isFetching = useSelector(selectIsFetching);
  const isExpiredList = useSelector(selectExpiredList);
  const relatedToExpired = useSelector(selectRelatedToExpired);

  const relatedToExpiredBool = Boolean(relatedToExpired);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.getExpiredCount({ relatedToExpired: relatedToExpiredBool })
    );
  }, [relatedToExpiredBool, dispatch]);

  const frg = isExpiredList ? 'white' : 'red';
  const bkg = isExpiredList ? 'red' : 'white';

  const handleClick = () => {
    isExpiredList
      ? dispatch(requestsActions.fetchRequests())
      : dispatch(requestsActions.fetchExpiredRequests());
  };

  return (
    <Tooltip
      title="Просроченные заявки"
      placement="bottom"
    >
      <Button
        shape="round"
        icon="fire"
        style={{ color: frg, background: bkg, marginRight: '10px' }}
        type="danger"
        disabled={!count}
        loading={isFetching}
        onClick={handleClick}
      >
        <span style={{ fontWeight: 'bold' }}>{count}</span>
      </Button>
    </Tooltip>
  );
};

export default DspxExpiredReqButton;
